<template>
		<ul v-show="initialData.length > 0" class="milestone-list">
			<li class="row milestone-title">
				<div class="col-xs-9">
					<b>Payment Term Name & Description</b>
				</div>
				<div class="col-xs-3 text-right">
					<b>(%)</b>
				</div>
			</li>
			<li v-for="(item, index) in initialData" :key="index" class="row">
				<div class="col-xs-1">
					<delete-button 
						:onClick="() => removeMilestone(index)" 
						:disabled="isLoading"
					/>
				</div>
				<div class="col-xs-8">
					<textarea 
						class="form-control" 
						v-model="item.description"
						rows="3"
						:disabled="isLoading">
					</textarea>
					<br>
				</div>
				<div class="col-xs-3 text-right">
					<input 
						type="number" 
						min="0"
						class="form-control" 
						v-model="item.percentage"
						:disabled="isLoading"
					>
				</div>
			</li>
		</ul>
</template>

<script>
import InputWrapper from '../InputWrapper.vue';
import AddButton from "../AddButton.vue";
import DeleteButton from "../DeleteButton.vue";
import { defaultErrors, defaultFields } from './helpers';

export default {
	components: { AddButton, DeleteButton, InputWrapper, },
	props: {
		initialData: {
			type: Array,
			required: true
		},
		removeMilestone: {
			type: Function,
			required: true,
		},
		isLoading: {
			type: Boolean,
			required: true
		}
	},
}
</script>

<style lang="less" scoped>
.milestone-list {
	list-style-type: none;
	padding-left: 0;
	padding-top: 25px;
}
.milestone-title {
	padding-bottom: 20px;
}
</style>
